export default "__VITE_ASSET__06090ecc__"